module.exports = __webpack_public_path__ + "assets/img/img225.1ab710f0.png";